import * as modal from './modal';
import * as button from './button';

$(function () {

    // アルバム複製モーダル（Submit）
    $("#copyAlbum_submit").on("click", function () {
        // ボタンを無効に
        button.invalid(this);

        // セレクトした写真を取得
        let uuid_list = [];
        $('input:checkbox[name="selectimg"]:checked').each(function () {
            uuid_list.push($(this).val());
        });

        // アルバム複製へ
        copyAlbum(uuid_list, copy_title.value, this);
    });
    
});

//　アルバム複製
export function copyAlbum(uuid_list, copy_title, thisElem) {

    $.ajax({
        type: 'POST',
        url: mypath + 'copyalbum',
        data: {
            'album_uuid': album_uuid,
            'uuid_list': uuid_list,
            'copy_title': copy_title
        },
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {
                
                if (res['flag']) {
                    // 新しいアルバムへ移動
                    location.href = mypath + 'home';
                } else {
                    // ボタンを有効に
                    button.valid(thisElem);

                    Swal.fire({
                        title: 'エラー',
                        text: res['error'] ? res['error'] : '作成に失敗しました',
                        confirmButtonText: 'OK'
                    });
                    console.log(res['error']);
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                // ボタンを有効に
                button.valid(thisElem);

                // バリデーションエラー
                if (XMLHttpRequest.responseJSON.errors) {
                    Swal.fire({
                        title: '入力エラー',
                        text: '入力内容に誤りがあります',
                        confirmButtonText: 'OK'
                    });
                }
            });
}